import { Button } from "@/components/ui/button";
import { Delete } from "lucide-react";
import { useKeypadKeys } from "@/hooks/useKeypadKeys";

// Shared 4-6 digit PIN pad following the NEEC numeric-input standard (keyboard, numpad, mouse, touch).
export default function PinPad({ pin, setPin, onSubmit, onCancel, active = true, error, busy, submitLabel = "Continue", testPrefix = "pin" }) {
  const press = (d) => setPin((p) => (p.length < 6 ? p + d : p));
  useKeypadKeys({ active: active && !busy, onDigit: press, onBackspace: () => setPin((p) => p.slice(0, -1)),
    onClear: () => setPin(""), onEnter: () => pin.length >= 4 && onSubmit(), onEscape: onCancel });
  return (
    <div>
      <div className="flex justify-center gap-2 my-3" data-testid={`${testPrefix}-dots`}>
        {[0, 1, 2, 3, 4, 5].map((i) => (
          <div key={i} className={`w-6 h-8 rounded-md border-2 flex items-center justify-center mono text-lg ${i < pin.length ? "border-violet-500 bg-violet-500/10" : "border-border"}`}>{i < pin.length ? "•" : ""}</div>
        ))}
      </div>
      {error && <p className="text-center text-sm text-rose-500 mb-2" data-testid={`${testPrefix}-error`}>{error}</p>}
      <div className="grid grid-cols-3 gap-2">
        {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((d) => (
          <Button key={d} type="button" variant="outline" className="h-14 text-xl mono" data-testid={`${testPrefix}-key-${d}`} onClick={() => press(String(d))}>{d}</Button>
        ))}
        <Button type="button" variant="outline" className="h-14" onClick={() => setPin((p) => p.slice(0, -1))} data-testid={`${testPrefix}-back`}><Delete className="w-5 h-5" /></Button>
        <Button type="button" variant="outline" className="h-14 text-xl mono" data-testid={`${testPrefix}-key-0`} onClick={() => press("0")}>0</Button>
        <Button type="button" className="h-14 bg-violet-600 hover:bg-violet-700 text-white" disabled={busy || pin.length < 4} onClick={onSubmit} data-testid={`${testPrefix}-submit`}>{busy ? "…" : submitLabel}</Button>
      </div>
      <p className="text-center text-[11px] text-muted-foreground mt-2">Keyboard or numpad · Enter to continue · Esc to go back</p>
    </div>
  );
}
